<div class="devices-container">
  <div class="page-top-banner">
    <h1>Périphériques</h1>
    <div class="action-zone">
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Plateforme :</mat-label>
        <mat-select [(ngModel)]="platform" (ngModelChange)="onPlatformChange()">
          <mat-option value="Centrex NG">Centrex NG</mat-option>
          <mat-option value="Centrex Enreach">Centrex Enreach</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="table-container">
    <form class="filters-form" [formGroup]="filtersForm">
      <div class="mat-elevation-z8 general-table">
        <table mat-table class="default-table" [dataSource]="dataSource" matSort>

          <!-- Nom -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Nom</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="name" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('name')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let dev">{{ dev.name }}</td>
          </ng-container>

          <!-- Site -->
          <ng-container matColumnDef="site">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Site</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="site" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('site')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let dev">{{ dev.siteName || '—' }}</td>
          </ng-container>

          <!-- Modèle -->
          <ng-container matColumnDef="modelName">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Modèle</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="modelName" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('modelName')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let dev">{{ dev.modelName }}</td>
          </ng-container>

          <!-- Périphérique ID -->
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Périphérique ID</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="address" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('address')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let dev">{{ dev.address }}</td>
          </ng-container>

          <!-- Extension -->
          <ng-container matColumnDef="extension">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>Extension</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="extension" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('extension')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let dev">
              {{ dev.extensionIds?.join(', ') || '—' }}
            </td>
          </ng-container>

          <!-- SDA -->
          <ng-container matColumnDef="sda">
            <th mat-header-cell *matHeaderCellDef>
              <span mat-sort-header>IP</span>
              <div class="small">
                <mat-form-field appearance="outline">
                  <input matInput formControlName="sda" (keyup)="applyFilters()" />
                  <button mat-icon-button matSuffix (click)="resetColumnFilter('sda')">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </th>
            <td mat-cell *matCellDef="let dev">
              {{ dev.publicAddress || '—' }}
            </td>
          </ng-container>

          <!-- Statut -->
          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>Statut</th>
            <td mat-cell *matCellDef="let dev">
              <mat-icon color="{{ dev.state === 'registered' ? 'primary' : 'warn' }}">
                {{ dev.state === 'registered' ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </td>
          </ng-container>

          <!-- Actions -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let dev">
              <div class="actions-cell">
                <button mat-icon-button (click)="onView(dev)">
                  <mat-icon>visibility</mat-icon>
                </button>
                @if (isFullAccess) {
                <button mat-icon-button (click)="onEdit(dev)">
                  <mat-icon>edit</mat-icon>
                </button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </form>
  </div>
</div>
<mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
  [fullScreen]="true"></ngx-spinner>